<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import StarReview from '../parts/reviews/starReview.svelte';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			theme: 'yellow' | 'brown';
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div use:editable={content}>
	<StarReview theme={content.theme || 'yellow'} />
</div>
